// src/components/modals/DetailsModal/skeletons/DetailsModalSkeleton.js
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const DetailsModalSkeleton = ({ sensesCount = null }) => (
  <div className="flex flex-col h-full">
    {/* — Modal Header Chrome - matches DetailsModal */}
    <div className="p-4 flex-shrink-0 flex justify-between items-center bg-primary/5 border-b border-border">
      <div className="flex items-center">
        <Skeleton circle width={32} height={32} className="mr-3" />
        <Skeleton width={60} height={24} />
      </div>
      <Skeleton circle width={24} height={24} />
    </div>

    {/* — Item Header skeleton (ModalHeader content) */}
    <div
      className="
        p-6 md:p-8
        bg-gradient-to-br from-background-secondary to-background-primary
        border-b-2 border-border
        relative
      "
    >
      {/* Top-left badges */}
      <div className="absolute top-4 left-4 flex space-x-2">
        <Skeleton circle width={24} height={24} />
        <Skeleton circle width={24} height={24} />
      </div>

      {/* Top-right "Next" badge */}
      <div className="absolute top-4 right-4">
        <Skeleton width={60} height={20} />
      </div>

      {/* Furigana toggle (centered) */}
      <div className="absolute top-4 inset-x-0 flex justify-center">
        <Skeleton circle width={24} height={24} />
      </div>

      {/* Play button */}
      <div className="mt-8 flex justify-center">
        <Skeleton circle width={80} height={80} />
      </div>

      {/* Word/Sentence display */}
      <div className="mt-6 flex justify-center">
        <Skeleton width={120} height={24} />
      </div>
    </div>

    {/* — Tabs skeleton */}
    <div className="border-b border-border sticky top-0 bg-background-secondary z-10">
      <nav className="flex px-4 md:px-6 gap-2 py-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} containerClassName="flex-1" height={32} style={{ borderRadius: '8px' }} />
        ))}
      </nav>
    </div>

    {/* — Content skeleton */}
    <div className="p-6 flex-grow">
      {sensesCount === 1 ? (
        // Single sense layout - matches DetailsTab single sense structure
        <div className="space-y-3">
          <div className="flex">
            <div className="mr-4 pt-2">
              <Skeleton circle width={12} height={12} />
            </div>
            <div className="flex-grow">
              <Skeleton width="60%" height={20} className="mb-3" />
              <Skeleton width="40%" height={14} className="italic" />
            </div>
          </div>
        </div>
      ) : sensesCount && sensesCount > 1 ? (
        // Multiple senses layout - show approximate content based on actual count
        <div className="space-y-3">
          {Array.from({ length: Math.min(sensesCount * 2, 8) }).map((_, i) => (
            <Skeleton key={i} height={18} />
          ))}
        </div>
      ) : (
        // Default layout when we don't know the count
        <div className="space-y-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height={18} />
          ))}
        </div>
      )}
    </div>

    {/* — Footer skeleton */}
    <div className="flex-shrink-0 p-4 bg-background-primary border-t-2 border-border flex flex-wrap justify-end items-center gap-1 sm:gap-2">
      {Array.from({ length: 3 }).map((_, i) => (
        <Skeleton key={i} width={80} height={40} className="sm:w-24" style={{ borderRadius: '8px' }} />
      ))}
    </div>
  </div>
);

export default DetailsModalSkeleton;
